<template>
    <div class="">
        <div class="container box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <div class="tags has-addons">
                                <span class="tag is-medium is-white">
                                    <img src="../../assets/icons/user.png" height="32" width="32"/>
                                </span>
                            <span class="tag is-medium is-light">
                            <p class="subtitle">Permissions of User</p>
                            </span>
                            <span class="tag is-medium is-dark is-light">{{selectedUserName}}</span>
                        </div>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <router-link :to="{name:'Users'}">
                            <button
                                    class="button button-hover modified-button">
                                                <span class="icon">
                                                    <font-awesome-icon icon="long-arrow-alt-left" class="icon"
                                                                       size="sm"/></span>
                                <span>Back To Users</span>
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>

        </div>
        <div class="columns">
            <div class="column is-2">
                <aside class="menu menu-content">
                    <p class=" has-text-centered">
                        <span class="subtitle has-text-centered"><strong>Projects</strong></span>
                    </p>
                    <hr>
                    <ul class="menu-list">

                        <li v-for="project in projectsOfUserOrderBy " :key="project.id">
                            <a v-bind:class="{'is-active': selectedProjectId === project.id,'not-perm-project':project.fStatus==0}"
                               @click="setProject(project.id)">{{project.name}}
                            </a>
                        </li>

                    </ul>
                </aside>

            </div>

            <div class="column is-10">
                <div v-if="selectedProjectId==0" class="notification">
                    <strong>Please select one project</strong>,
                </div>
                <div v-else class="columns">
                    <div class="column is-6">
                        <h1 class="subtitle has-text-centered"><strong>User RoFle Management</strong></h1>

                        <div class="level">
                            <div class="level-item">
                                <div class="table modified-table">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th colspan="3" class="has-text-centered"><strong style="color: white">Possible
                                                Roles</strong>
                                            </th>
                                        </tr>
                                        </thead>
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Role Name</th>
                                            <th>Act</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="rp in filteredPossibleRoles" :key="rp.id">

                                            <td>
                                                <figure class="image is-16x16">
                                                    <img src="../../assets/icons/permission.png" height="32"
                                                         width="32"/>
                                                </figure>
                                            </td>
                                            <td>{{rp.name}}</td>
                                            <td>
                                                <font-awesome-icon @click="TryAddRole(rp.id,rp.name)"
                                                                   icon="plus"
                                                                   size="lg" class="modified-color-red button-hover"
                                                                   style="cursor: pointer"
                                                                   title="Add role this user"
                                                />
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="level-item">

                                <div class="table modified-table" style="margin-left: 10px">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th colspan="3" class="has-text-centered"><strong style="color: white">Users
                                                Roles</strong></th>
                                        </tr>
                                        </thead>
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Role Name</th>
                                            <th>Act</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="rp in userProjectRoles" :key="rp.id">

                                            <td>
                                                <figure class="image is-16x16">
                                                    <img src="../../assets/icons/permission.png" height="32"
                                                         width="32"/>
                                                </figure>
                                            </td>
                                            <td>{{rp.name}}</td>
                                            <td>
                                                <font-awesome-icon @click="TryDeleteRole(rp.id,rp.name)"
                                                                   icon="trash-alt"
                                                                   size="lg" class="modified-color-red button-hover"
                                                                   style="cursor: pointer"
                                                                   title="Add role this user"
                                                />
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="vr"></div>
                    <div class="column is-6">
                        <h1 class="subtitle has-text-centered"><strong>User Permission Management</strong></h1>

                        <div class="level">
                            <div class="level-item">
                                <div class="table modified-table">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th colspan="4" class="has-text-centered">
                                                <strong style="color: #F5F5F5">All Permission</strong>
                                            </th>
                                        </tr>
                                        </thead>
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Permisson</th>
                                            <th>Default</th>
                                            <th>Custom</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="rp in permissions" :key="rp.id">

                                            <td>
                                                <figure class="image is-16x16">
                                                    <img src="../../assets/icons/permission.png" height="32"
                                                         width="32"/>
                                                </figure>
                                            </td>
                                            <td>{{rp.name}}</td>
                                            <td>
                                                      <span>
                                                            <button class="button is-small is-danger"
                                                                    style="width: 50px" title=""

                                                                    @click="SetPermissionForRole(role.id,permission.id)">
                                                              <font-awesome-icon
                                                                      icon="times"
                                                                      size="lg"/>
                                                            </button>
                                                    </span>
                                            </td>
                                            <td>
                                                    <span>
                                                            <button class="button is-small is-danger"
                                                                    style="width: 50px" title=""

                                                                    @click="SetPermissionForRole(role.id,permission.id)">
                                                              <font-awesome-icon
                                                                      icon="times"
                                                                      size="lg"/>
                                                            </button>
                                                    </span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: "UserDetails",
        data() {
            return {
                selectedUserId: this.$route.params.selectedUserId,
                selectedUserName: this.$route.params.selectedUserName,
                selectedProjectId: 1,
            }
        },
        methods: {
            ...mapActions('projects',
                ['getProjects', 'getProject',
                    'getUserProject', 'getProjectOfUser',
                    'addUserProject', 'addProject',
                    'openCloseProjectModal', 'deleteUser']),
            ...mapActions('roles',
                ['getRoles', 'getRolesOfProject',
                    'addRole', 'addUserRole',
                    'deleteRole', 'getPermissions',
                    'getRolePermissions', 'addRolePermission',
                    'getPermissionsByProject', 'getUserProjectRoles', 'deleteUserRole']),


            async TryAddRole(id, name) {
                await this.$swal({
                    title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to add role "' + name + '"  . Are you sure?</p>',
                    html: "",
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#ec2929d4',
                    confirmButtonColor: '#1e3e67',
                    confirmButtonText: 'Yes',
                }).then(async (response) => {
                    if (response.value) {
                        try {
                            await this.addUserRole({userId: this.selectedUserId, roleId: id});
                            await this.refreshBusinessData();
                            await this.this.$notify({
                                title: "Success",
                                text: "User role added successfully. ",
                                type: "success"
                            });

                        } catch (e) {
                            this.$notify({
                                title: "Error",
                                text: "Failed to added user role.." + e.message,
                                type: "error"
                            });
                        }
                    }
                });
            },

            async TryDeleteRole(id, name) {
                await this.$swal({
                    title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to delete role "' + name + '"  . Are you sure?</p>',
                    html: "",
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#ec2929d4',
                    confirmButtonColor: '#1e3e67',
                    confirmButtonText: 'Yes',
                }).then(async (response) => {
                    if (response.value) {
                        try {
                            await this.deleteUserRole(id);
                            await this.refreshBusinessData();
                            this.$notify({
                                title: "Success",
                                text: "User role  deleted deleted successfully. ",
                                type: "success"
                            });

                        } catch (e) {
                            this.$notify({
                                title: "Error",
                                text: "Failed to delete user role.." + e.message,
                                type: "error"
                            });
                        }
                    }
                });
            },

            async refreshData() {
                await this.getProjectOfUser();
                await this.getPermissions();
            },
            async refreshBusinessData() {
                await this.getRolesOfProject(this.selectedProjectId);
                await this.getUserProjectRoles({userId: this.selectedUserId, projectId: this.selectedProjectId});
            },
            setProject(value) {
                this.selectedProjectId = value;
                this.getRolesOfProject(this.selectedProjectId);
                this.getUserProjectRoles({userId: this.selectedUserId, projectId: this.selectedProjectId});
            },
        },

        computed: {
            ...mapState('projects',
                ['projects', 'project',
                    'projectsOfUser', 'userProject',
                    'isActiveProjectModal']),
            ...mapState('roles',
                ['roles', 'rolesOfProject',
                    'rolePermissions', 'permissions',
                    'projectPermissions', 'userProjectRoles']),

            projectsOfUserOrderBy() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return this.projectsOfUser.sort((a, b) => (a.fStatus < b.fStatus) ? 1 : -1)

            },
            filteredPossibleRoles: function () {
                return this.rolesOfProject.filter(i => !this.userProjectRoles.find(j => j.id == i.id))
            },

        },
        async created() {
            await this.refreshData();
        }
    }
</script>

<style scoped>
    .vr {
        border-left: 5px solid #1e3e67;
        height: 790px;
        margin-left: -3px;
    }

    .not-perm-project {
        pointer-events: none;
        background-color: #e4e4e4;
    }

    .menu-content {
        padding-inline: 1px;
        padding-top: 8px;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
    }

    .perm-table {
        max-height: 300px;
    }


</style>
